
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/au/privacy-policy",
      function () {
        return require("private-next-pages/au/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/au/privacy-policy"])
      });
    }
  